import * as React from 'react'
import { connect } from 'react-redux'
import { Action } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { DataTable } from 'damco-components'
import { findObjId, findObjById } from 'utilities/util'
import { DialogSubTableWrapperNew } from './DialogSubTableWrapperNew'
import { InPageDialog } from 'damco-components'
import CostColumnsData from '../../../views/job-costing/utils/CostColumnsData'
import { currentPageMode } from '../../../constants/customs'
import { IStore } from 'reducers/index'
import { fetchDistributionData } from 'actions/costRevenue'
import { PartyComponentNew } from './PartyComponentNew'
import { IChargeItem, IEquipments, IExportJob } from 'reducers/cbl/models'

interface IMapDispatchToProps {
  fetchDD: (valueId: number) => Promise<void>;
}
interface IMapStateToProps {
  isFetchDataLoading: boolean;
  isFetchDataError: boolean;
  pendingError: string | string[],
  distributionData: IExportJob[];
  chargeItemData: any[];
}

interface IProps extends IMapStateToProps, IMapDispatchToProps{
    data: any[];
    columns: any[];
    subColumns: any[];
    showSub: boolean;
    distribution: number;
    index: number;
    type: string,
    target: string,
    isSelectable: boolean;
    quantity: number;
    targetFunctionality: number;
    displayDistribution: boolean;
    fetchData: (e: any, table: any) => void,
    setCurrentIndex: (e: any) => void;
    returnRef: (e: any) => void;
    onSelectCallBack: (e: any[] | null, data:any) => void;
    closeMethod: () => void;
    deleteCharge?: (item:any, selectedTable: any) => void;
    costAndRevenueId: number;
    isExtraDocumentFeatureEnabled: boolean;
    partyComponentErrorList: any[];
    partyComponentTarget:any;
    updateChargeItems: (data:any[], idx: number) => void;
    updateKeyInExportJob: (idx:number, key:string, value:any) => void;
    updateDistributionSplitSelection: (status:boolean) => void;
    partyCheckboxStatus: boolean
}
interface IHandlerState {
    prevIndex: number,
    wasOpen: boolean,
}
interface IState {
    shouldCheck: boolean,
    showDialog: boolean,
    errorMsg: string,
    timeout: boolean,
    subCols: any[],
    isExpanded: boolean,
    childPosition: number,
    prevHandlerState: IHandlerState,
    exportJobPartySelectionDisabled:boolean,
    localChargeItemEdit: any[],
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
  isFetchDataLoading: state.newCostRevenue.isFetchDataLoading,
  isFetchDataError: state.newCostRevenue.isFetchDataError,
  pendingError: state.newCostRevenue.pendingError,
  distributionData: state.newCostRevenue.distributionData,
  chargeItemData: state.newCostRevenue.chargeItemData,
})

const setDropDownValue = (value:string|number, obj:any, propertyName:string) =>{
  const objList = findObjById(value, obj, propertyName)
  if(objList){
    return objList
  }
  return value
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
  fetchDD: (cblId: number) => dispatch(fetchDistributionData(cblId)),
})

export class _DialogTableWrapper extends React.Component<IProps, IState> {
  public static isRunning = false
  public selectTable: any = React.createRef()
  public myTableWrap: any = null
  constructor(props: IProps) {
    super(props)
    this.state = {
      shouldCheck: false,
      subCols: [],
      isExpanded: false,
      showDialog: false,
      timeout: false,
      errorMsg: '',
      childPosition: 99999,
      prevHandlerState: {
        prevIndex: 0,
        wasOpen: false
      },
      exportJobPartySelectionDisabled: false,
      localChargeItemEdit: []
    }
    this.handleMasterCheckSelection = this.handleMasterCheckSelection.bind(this)
  }
  public componentDidMount() {
    this.myTableWrap = document.querySelector('.dialog-table-wrapper')
    if(this.props.type === currentPageMode.add) {
      this.props.fetchDD(this.props.costAndRevenueId)
    }
    else{
      this.setState({
        localChargeItemEdit: this.props.chargeItemData
      })
    }
  }
  // This will launch only if propName value has chaged.
  public componentDidUpdate(props: any, prevState: any) {
    if(this.props.type === currentPageMode.add && this.props.distributionData !== props.distributionData){
      if(!this.props.isFetchDataLoading){
        this.manipulateData(this.props.distributionData, this.props.index)
      }
    }
    if(this.props.type === currentPageMode.edit && this.state.localChargeItemEdit !== prevState.localChargeItemEdit){
      this.state.localChargeItemEdit.forEach((charge:any, idx: number)=>{
        this.manipulateData(charge.distributionData, idx)
      })
    }
    if (props.index !== this.props.index && this.props.data.length > 0 && this.props.distributionData !== props.distributionData) {
      if(this.props.type === currentPageMode.add){
        this.manipulateData(this.props.distributionData, this.props.index)
      }
      else{
        this.state.localChargeItemEdit.forEach((charge:any, idx: number)=>{
          this.manipulateData(charge.distributionData, idx)
        })
      }
      this.props.closeMethod()
      this.setSelected()
    }
    if (this.props.data && this.props.data.length > 0 && this.props.data !== props.data) {
      this.setSelected()
      // update checkbox for child data table
      this.props.updateDistributionSplitSelection(true)
    }
    if(this.props.partyCheckboxStatus !== props.partyCheckboxStatus){
      this.setState({exportJobPartySelectionDisabled:this.props.partyCheckboxStatus})
    }
  }

  public componentWillUnmount(){
    this.setState({
      localChargeItemEdit: []
    })
  }

  public manipulateData = (data:any, chargeIdx: number) => {
    this.props.updateDistributionSplitSelection(false)
    if(data?.length > 0){
      // add id to each row of distribution data as data-table checkbox needs unique id
      const distributionData = JSON.parse(JSON.stringify(data))
      distributionData.forEach((obj:IExportJob)=>{
        obj.splits.forEach((ele:IEquipments, idx:number)=>{
          ele.id = idx
        })
      })
      this.props.updateChargeItems(distributionData, chargeIdx)
    }
    else{
      this.props.updateChargeItems([], chargeIdx)
    }
  }

  public render() {
    const getCols = () => {
      switch (this.props.targetFunctionality) {
      case 5:
        return CostColumnsData.getETSDialogSubCols()
        break
      case 4:
        return CostColumnsData.getDialogFcrCostRevSubCols()
        break
      case 3:
        return CostColumnsData.getDialogCblDataDistributionSubCols(this.props.isExtraDocumentFeatureEnabled)
        break
      case 2:
        return CostColumnsData.getDialogEqCostRevSubCols(this.props.isExtraDocumentFeatureEnabled)
        break
      default:
        return CostColumnsData.getDialogBookingCostRevSubCols(this.props.isExtraDocumentFeatureEnabled)
      }
    }

    if (this.props.data && this.props.columns && this.props.subColumns) {
      return (
        <div className={'table-group-relative'}>
          <InPageDialog
            showDialog={this.state.showDialog}
            type={'error'}
            message={this.state.errorMsg}
            closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
          <div id="add-edit-dialog-table">
            <DataTable
              data={...this.props.data}
              columns={...this.props.columns}
              isEditable={false}
              isSelectable={true}
              selectedOption={'single'}
              isSortable={true}
              isExpandable={false}
              isResizable={true}
              hasFooter={true}
              ref={this.selectTable}
              linkAction={this.onTargetClick}
              actions={this.props.type === currentPageMode.add && this.props.data.length > 1 && {
                secondaryActions: [],
                parentContextualActions: []
              }}
              manualPagination={true}
              fetchData={this.props.fetchData}
              tableName={'dialog-table-wrapper'}
              showPagination={this.props.data.length && this.props.data.length > 10 ? true : false}
            />
          </div>
          <div className="table-group-absolute multiple-export-job-distribution">
            <p>Distribution Data:</p>
            {this.props.data[this.props.index].children?.length > 0 && this.props.data[this.props.index].children.map((item: IExportJob, i: number) => {
              return (<div className="custom-border-box" key={`item-${this.props.index}-${i}`}>
                <div className="d-flex">
                  <h3 className="d-flex title">Job no: {item.finNumber}</h3>
                  <div className={this.props.type === currentPageMode.edit ? 'flex-direction-column mb-1' : 'd-flex export-job'}>
                    <div className="d-flex">
                      <PartyComponentNew
                        dataListId={`export-job-party-dropdown-${this.props.index}-${i}`}
                        className="export-job-party-component"
                        data={item}
                        errorList={(this.props.partyComponentErrorList?.length && this.props.partyComponentErrorList[i])?this.props.partyComponentErrorList[i].split(' '):[]}
                        callbackDropdown={setDropDownValue}
                        onUpdate={(key:any, value:any)=>this.onPartyComponentUpdate(key, value, i)}
                        target={this.props.partyComponentTarget}
                        isDisabled={this.state.exportJobPartySelectionDisabled}
                      />
                      <label>ICB Indicator : {item.icbIndicator?item.icbIndicator:'-'}</label>
                    </div>
                    {this.props.type === currentPageMode.edit && <div className="d-flex item-status">Charge Item Status :&nbsp;<span>{item.status?item.status : '-'}</span></div>}
                  </div>
                </div>
                <DialogSubTableWrapperNew
                  className={`distribution-data-table-${i}`}
                  data={item.splits}
                  cols={getCols()}
                  updateTable={this.props.data[this.props.index].updateChildrenStatus}
                  onchange={(a: boolean, list: any[]) => {
                    if (list.length === 0) {
                      this.handleMasterCheckSelection(a, i)
                    } else {
                      this.updateChildrenSelection(list, i)
                    }
                  }}
                  distributionType={this.props.distribution}
                  isSelectable={this.props.displayDistribution}
                  subTableRef={React.createRef()}
                  targetLevel={this.props.targetFunctionality}
                  onChildTableUpdate={()=>{this.props.updateDistributionSplitSelection(false)}}
                />
              </div>
              )
            })}
          </div>
        </div>
      )
    } else {
      return <div />
    }
  }
  public onPartyComponentUpdate=(key:any, value:any, exportJobId:number) => {
    this.props.updateKeyInExportJob(exportJobId, key, value)
  }
  public updateChildrenSelection = (childrenStatus:any[], tableIndex:number)=>{
    const newData: any[] = [...this.props.data]
    newData[this.props.index].children[tableIndex].splits = newData[this.props.index].children[tableIndex].splits.map((child: IEquipments, index: number) => {
      child.select = childrenStatus[index]
      return child
    })
    this.props.onSelectCallBack(childrenStatus, newData)
  }
  public handleMasterCheckSelection = (value: boolean, tableIndex: number) => {
    // childIndex.stopPropagation();
    const targ = this.props.data[this.props.index].children[tableIndex].splits
    const arr = Array.from({length: targ.length}).map(()=>value)
    this.updateChildrenSelection(arr, tableIndex)
  }
  public setSelected = () => {
    setTimeout(() => {
      const htmlEl = this.getTableRows()
      if (htmlEl) {
        const currentEl = htmlEl[this.props.index]
        if (currentEl && currentEl.parentElement) {
          currentEl.classList.add('-selected')
          if (currentEl.querySelector('input')) {
            currentEl.querySelector('input').checked = true
          }
        }
      }
    }, 200)
  }
  public getTableRows = () => {
    if (!this.myTableWrap) {
      this.myTableWrap = document.querySelector('.dialog-table-wrapper')
    }
    if (this.myTableWrap) {
      const htmlEl = this.myTableWrap.querySelectorAll('.rt-tbody .rt-tr-group')
      if (htmlEl && htmlEl.length > 0) {
        const lgt = htmlEl.length > this.props.data.length ? this.props.data.length : htmlEl.length
        for (let i = 0; i < lgt; i++) {
          if (htmlEl[i] && htmlEl[i].parentElement && i !== this.props.index) {
            htmlEl[i].classList.remove('-selected')
            if (htmlEl[i].querySelector('input') && !htmlEl[i].querySelector('input').hasAttribute('listenerOnClick')) {
              htmlEl[i].querySelector('input').checked = false
              htmlEl[i].querySelector('input').addEventListener('click', (e: any) => {
                this.handleRadioSelection(e, i)
              })
              htmlEl[i].querySelector('input').setAttribute('listenerOnClick', 'true')
            }
          }
        }
      }
      return htmlEl
    }
  }
  public handleRadioSelection = (ev: any, index: number) => {
    ev.preventDefault()
    ev.stopPropagation()
    this.props.setCurrentIndex(index)
  }
  public onTargetClick = (item: IChargeItem) => {
    if(this.props.deleteCharge) {
      this.props.deleteCharge(item, this.selectTable.current.getData())
    }
    const findById = findObjId(item.id, this.props.data, 'id')
    if (this.props.index !== findById && this.state.isExpanded) {
      this.setState({
        isExpanded: false,
        prevHandlerState: {
          prevIndex: this.props.index,
          wasOpen: false
        }
      })
    }
    this.setSelected()
  }
}

export const DialogTableWrapperNew = connect<IMapStateToProps, IMapDispatchToProps, unknown, IStore>(mapStateToProps, mapDispatchToProps)(_DialogTableWrapper)
